var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-4"},[_c('HMStudioBackButton'),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col h1 mb-md-4 mt-2"},[_vm._v(" "+_vm._s(_vm.$t('STUDIO.TITLE.REDEMPTIONS'))+" ")])]),_c('StudentClassCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }